module.exports = __webpack_public_path__ + "eafc49f5f1b4c3e457da91d2db7fea73.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/user2-160x160.jpg
// module id = ./assets/images/user2-160x160.jpg
// module chunks = 0